/**
 * Open / download contractor master contract PDF via authenticated blob.
 * Never navigate to relative API paths on the SPA origin.
 */

export const openPdfBlobInNewTab = (blob) => {
  if (!blob) return false;
  const pdfBlob =
    blob.type && blob.type.includes("pdf")
      ? blob
      : new Blob([blob], { type: "application/pdf" });
  const url = URL.createObjectURL(pdfBlob);
  const win = window.open(url, "_blank", "noopener,noreferrer");
  if (!win) {
    // Popup blocked — fallback to same-tab navigation
    window.location.href = url;
  }
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
  return true;
};

export const downloadPdfBlob = (blob, fileName = "contractor-contract.pdf") => {
  if (!blob) return false;
  const pdfBlob =
    blob.type && blob.type.includes("pdf")
      ? blob
      : new Blob([blob], { type: "application/pdf" });
  const url = URL.createObjectURL(pdfBlob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 30_000);
  return true;
};
